<template>
  <div>
    <div id="func-content">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row mt-3">
                  <label class="control-label col-md-2">品牌：</label>
                  <div class="col-md-3">
                    <select
                          id="brands-code"
                          name="brandsCode"
                          class="form-control"
                          v-model="search.brandCode"
                        >
                        <option
                          v-for="x in selectListBrands"
                          v-bind:value="x.Code"
                          :key="x.Code"
                        >{{x.Text}}</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-3">
                  <label class="control-label col-md-2">店號：</label>
                  <div class="col-md-3">
                    <input type="text" class="form-control" v-model="search.code" placeholder="請輸入店號">
                  </div>
                  <label class="control-label col-md-2">店名：</label>
                  <div class="col-md-3">
                    <input type="text" class="form-control" v-model="search.name" placeholder="模糊搜尋">
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-ptc1" @click="btnQuery">查詢</button>
                    <button type="button" class="btn btn-ptc1" @click="reset">重設</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>

      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-6">
                    <h3></h3>
                  </div>
                  <div class="col-lg-12 mt-2">
                    <div class="table-responsive">
                      <table class="table table-bordred table-striped">
                        <thead>
                          <tr>
                            <th>項次</th>
                            <th>品牌</th>
                            <th>店號</th>
                            <th>店名</th>
                            <th>信用卡</th>
                            <th>街口</th>
                            <th>LINE Pay</th>
                            <th>全支付</th>
                            <th>悠遊付</th>
                            <th>臨櫃付款</th>
                            <th>預約點餐</th>
                            <th>線上點餐</th>
                            <th>APP顯示</th>
                            <th>預購</th>
                            <th>智取櫃</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(x, index) in items" :key="x.ID" :id="x.ID">
                            <td>{{pageRows * (search.currentPage - 1) + index + 1}}</td>
                            <td>{{x.BrandCode}}</td>
                            <td>{{x.Code}}</td>
                            <td v-if='(x.LineCId=="" || x.LineCSk=="")&&(x.PxpayMCode=="" || x.PxpayStoreID=="")&&(x.EzpaySMemberUid=="" || x.EzpaySecurityCode=="")&&x.BankMid==""&&x.JkoMid==""&&x.Storepay==false' class="active">{{x.Name}}</td>
                            <td v-else>{{x.Name}}</td>
                            <td :class="{'isClose' : x.BankMid==''}">{{x.BankMid != '' ? '開放':'關閉' }}</td>
                            <td :class="{'isClose' : x.JkoMid==''}">{{x.JkoMid != '' ? '開放':'關閉' }}</td>
                            <td :class="{
                              'isClose' : (x.LineCId=='' && x.LineCSk==''),
                              'active' : (x.LineCId=='' && x.LineCSk!='') || (x.LineCId!='' && x.LineCSk=='')
                              }">{{x.LineCId != '' && x.LineCSk != '' ? '開放':'關閉' }}</td>
                            <td :class="{
                              'isClose' : (x.PxpayMCode=='' && x.PxpayStoreID==''),
                              'active' : (x.PxpayMCode=='' && x.PxpayStoreID!='') || (x.PxpayMCode!='' && x.PxpayStoreID=='')
                              }">{{x.PxpayMCode != '' && x.PxpayStoreID != '' ? '開放':'關閉' }}</td>
                            <td :class="(() => {
                              const count = [
                                x.EzpaySMemberUid,
                                x.EzpaySecurityCode,
                                x.EzpayContractNo,
                                x.EzpayExecutorID
                              ].filter(Boolean).length;

                              return {
                                isClose: count === 0,
                                active: count > 0 && count < 4
                              };
                              })()">
                              {{ (x.EzpaySMemberUid && x.EzpaySecurityCode && x.EzpayContractNo && x.EzpayExecutorID) ? '開放' : '關閉' }}
                            </td>
                            <td :class="{'isClose' : x.Storepay==''}">{{x.Storepay == true ? '開放':'關閉' }}</td>
                            <td :class="{'isClose' : x.Reserve==false}">{{x.Reserve == true ? '開放':'關閉' }}</td>
                            <td :class="{'isClose' : x.OrderOpen==false}">{{x.OrderOpen == true ? '開放':'關閉' }}</td>
                            <td :class="{'isClose' : x.AppShow==false}">{{x.AppShow == true ? '是':'否' }}</td>
                            <td :class="{'isClose' : x.PreOrder==false}">{{x.PreOrder == true ? '開放':'關閉' }}</td>
                            <td :class="{'isClose' : x.ParcelLocker==false}">{{x.ParcelLocker == true ? '開放':'關閉' }}</td>
                            <td>
                              <button v-b-tooltip.hover.top title="編輯" class="btn-circle btn-circle-ptc1" @click="showEdit(x)"><span class="fa fa-pencil-alt" v-if="FunctionPermission > 1"></span></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row" style="padding: 0 1rem">
                      <b-pagination size="md" :total-rows="totalRows" v-model="search.currentPage" :per-page="pageRows" @change="changePage"></b-pagination>
                      <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{totalRows}}筆</label>
                    </div>
                  </div>
                </div>

          </div>
        </div>
      </b-card>

      <!-- 編輯畫面Modal -->
      <b-modal ref="mdEdit" hide-footer size='lg' title='編輯'>
        <b-container fluid>
          <div class="row">
            <div class="col-lg-12">
              <div class='row mb-3'>
                <label class='control-label col-md-3'>品牌：</label>
                  <div class='col-md-7'>
                    {{md_item.BrandCode}}
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>店號：</label>
                  <div class='col-md-7'>
                    {{md_item.Code}}
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>店名：</label>
                  <div class='col-md-7'>
                    {{md_item.Name}}
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>銀行MID：</label>
                  <div class='col-md-7'>
                    <input type='text' class='form-control' v-model.trim='md_item.BankMid' placeholder='請輸入' maxlength="50" >
                    <div class="text-danger" v-if="valid_BankMid&&!md_item.BankMid">{{valid_BankMid}}</div>
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>街口MID：</label>
                  <div class='col-md-7'>
                    <input type='text' class='form-control' v-model.trim='md_item.JkoMid' placeholder='請輸入' maxlength="50" >
                    <div class="text-danger" v-if="valid_JkoMid&&!md_item.JkoMid">{{valid_JkoMid}}</div>
                  </div>
              </div>
              <hr />
              <div class='row mb-3'>
                <label class='control-label col-md-3'>LINE Pay</label>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>Channel ID：</label>
                  <div class='col-md-7'>
                    <input type='text' class='form-control' v-model.trim='md_item.LineCId' placeholder='請輸入' maxlength="50" >
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>Channel SecretKey：</label>
                  <div class='col-md-7'>
                    <input type='text' class='form-control' v-model.trim='md_item.LineCSk' placeholder='請輸入' maxlength="50" >
                  </div>
              </div>
              <hr />
              <div class='row mb-3'>
                <label class='control-label col-md-3'>全支付</label>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>Merchant Code：</label>
                  <div class='col-md-7'>
                    <input type='text' class='form-control' v-model.trim='md_item.PxpayMCode' placeholder='請輸入' maxlength="50" >
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>Store ID：</label>
                  <div class='col-md-7'>
                    <input type='text' class='form-control' v-model.trim='md_item.PxpayStoreID' placeholder='請輸入' maxlength="50" >
                  </div>
              </div>
              <hr />
              <div class='row mb-3'>
                <label class='control-label col-md-3'>悠遊付</label>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>Seller MemberUid：</label>
                <div class='col-md-7'>
                  <input type='text' class='form-control' v-model.trim='md_item.EzpaySMemberUid' placeholder='請輸入' maxlength="30" >
                </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>Security Code:</label>
                <div class='col-md-7'>
                  <input type='text' class='form-control' v-model.trim='md_item.EzpaySecurityCode' placeholder='請輸入' maxlength="64" >
                </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>Contract No：</label>
                <div class='col-md-7'>
                  <input type='text' class='form-control' v-model.trim='md_item.EzpayContractNo' placeholder='請輸入' maxlength="30" >
                </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>Executor ID：</label>
                <div class='col-md-7'>
                  <input type='text' class='form-control' v-model.trim='md_item.EzpayExecutorID' placeholder='請輸入' maxlength="30" >
                </div>
              </div>
              <hr />
              <div class='row mb-3'>
                <label class='control-label col-md-3'>臨櫃付款：</label>
                <div class="col-lg-2 mt-1">
                  <label>
                    <input class="radiobox-boom" type="radio" v-model.trim='md_item.Storepay' name="storepay" :value="true" > 開放
                  </label>
                </div>
                <div class="col-lg-2 mt-1">
                  <label>
                    <input class="radiobox-boom" type="radio" v-model.trim='md_item.Storepay' name="storepay" :value="false" > 關閉
                  </label>
                </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>預約點餐：</label>
                <div class="col-lg-2 mt-1">
                  <label>
                    <input class="radiobox-boom" type="radio" v-model.trim='md_item.Reserve' name="reserve" :value="true" > 開放
                  </label>
                </div>
                <div class="col-lg-2 mt-1">
                  <label>
                    <input class="radiobox-boom" type="radio" v-model.trim='md_item.Reserve' name="reserve" :value="false" > 關閉
                  </label>
                </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>線上點餐：</label>
                <div class="col-lg-2 mt-1">
                  <label>
                    <input class="radiobox-boom" type="radio" v-model.trim='md_item.OrderOpen' name="orderOpen" :value="true" @click="OrderOpenOnClick()"> 開放
                  </label>
                </div>
                <div class="col-lg-2 mt-1">
                  <label>
                    <input class="radiobox-boom" type="radio" v-model.trim='md_item.OrderOpen' name="orderOpen" :value="false" > 關閉
                  </label>
                </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>APP顯示：</label>
                <div class="col-lg-2 mt-1">
                  <label>
                    <input class="radiobox-boom" type="radio" v-model.trim='md_item.AppShow' name="appShow" :value="true" > 是
                  </label>
                </div>
                <div class="col-lg-2 mt-1">
                  <label>
                    <input class="radiobox-boom" type="radio" v-model.trim='md_item.AppShow' name="appShow" :value="false" :disabled="md_item.OrderOpen == true"> 否
                  </label>
                </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>預購：</label>
                <div class="col-lg-2 mt-1">
                  <label>
                    <input class="radiobox-boom" type="radio" v-model.trim='md_item.PreOrder' name="preOrder" :value="true"> 開放
                  </label>
                </div>
                <div class="col-lg-2 mt-1">
                  <label>
                    <input class="radiobox-boom" type="radio" v-model.trim='md_item.PreOrder' name="preOrder" :value="false" > 關閉
                  </label>
                </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>智取櫃：</label>
                <div class="col-lg-2 mt-1">
                  <label>
                    <input class="radiobox-boom" type="radio" v-model.trim='md_item.ParcelLocker' name="parcelLocker" :value="true"> 開放
                  </label>
                </div>
                <div class="col-lg-2 mt-1">
                  <label>
                    <input class="radiobox-boom" type="radio" v-model.trim='md_item.ParcelLocker' name="parcelLocker" :value="false" > 關閉
                  </label>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="row float-right cog-lg-12">
                <b-btn variant="primary" @click="editConfirm()">儲存</b-btn>&nbsp;
                <b-btn variant="secondary" @click="editCancel()">取消</b-btn>&nbsp;
              </div>
            </div>
          </div>
        </b-container>
      </b-modal>
      <!-- Delete Check Modal -->
      <b-modal ref="mdCheck" hide-footer title="分店MID修改">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定要修改 ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="edit">確定</b-btn>
              <b-btn variant="secondary" @click="delCancel">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>

    </div>
  </div>
</template>
<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js">
</script>
<script>
import {getFunctionPermission} from '../../../js/LoginUserFunction.js'
import {API_URL} from '../../../store/root.js'
import { DEFAULT_SEARCH_BRAND_CODE } from '@/constants/defaultValues.js'
import miniToastr from 'mini-toastr'
import VModal from 'vue-js-modal'
import axios from 'axios'
miniToastr.init()

export default {
  data () {
    return {
      search: {
        brandCode: DEFAULT_SEARCH_BRAND_CODE,
        code: '',
        name: '',
        currentPage: 1
      },
      totalRows: 0,
      pageRows: 20,
      startRowNum: 0,
      endRowNum: 0,
      items: [],
      md_id: 0,
      md_title: '',
      md_item: {
        BrandCode: '',
        ID: 0,
        Code: '',
        Name: '',
        BankMid: '',
        JkoMid: '',
        LineCId: '',
        LineCSk: '',
        PxpayMCode: '',
        PxpayStoreID: '',
        EzpaySMemberUid: '',
        EzpaySecurityCode: '',
        EzpayContractNo: '',
        EzpayExecutorID: '',
        Storepay: false,
        Reserve: false,
        OrderOpen: false,
        AppShow: false,
        PreOrder: false,
        ParcelLocker: false
      },
      API_URL: API_URL,
      FunctionPermission: 0,
      lists: [],
      valid_JkoMid: '',
      valid_BankMid: '',
      selectListBrands: [{ ID: 0, Code: '', Text: '全部' }]
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F27') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    }

    this.querySelectListBrands();

    var search = this.$route.params.search
    if (search !== undefined) {
      this.search = search
      console.log(this.search)
      this.query()
    } else {
      this.reset()
    }
  },
  methods: {
    reset () {
      this.search.code = ''
      this.search.name = ''
      this.search.currentPage = 1
      this.search.brandCode = DEFAULT_SEARCH_BRAND_CODE

      this.query()
    },
    btnQuery () {
      this.search.currentPage = 1
      this.query()
    },
    query () {
      var brandcode, name, code, page, pageRows

      brandcode = this.search.brandCode
      name = this.search.name
      code = this.search.code
      page = this.search.currentPage
      pageRows = this.pageRows

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getPageStore', {
        brandcode: brandcode,
        code: code,
        name: name,
        page: page,
        pageRows: pageRows
      })
        .then((response) => {
          // console.log(response.data)
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.items = response.data.data
            this.totalRows = (response.data.count === undefined) ? 0 : response.data.count
            this.search.currentPage = page // 分頁處理 : 從編輯頁回列表時，跳回目前分頁
            this.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.pageRows * (this.search.currentPage - 1) + 1;
            this.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.pageRows > response.data.count) ? response.data.count : (this.search.currentPage * this.pageRows) >= response.data.count ? response.data.count : this.search.currentPage * this.pageRows;
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            this.items = []
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.items = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    changePage (page) {
      this.search.currentPage = page
      this.query()
    },
    showEdit (item) {
      this.md_item.BrandCode = item.BrandCode
      this.md_item.ID = item.ID
      this.md_item.Code = item.Code
      this.md_item.Name = item.Name
      this.md_item.BankMid = item.BankMid
      this.md_item.JkoMid = item.JkoMid
      this.md_item.Storepay = item.Storepay
      this.md_item.Reserve = item.Reserve
      this.md_item.OrderOpen = item.OrderOpen
      this.md_item.AppShow = item.AppShow
      this.md_item.PreOrder = item.PreOrder
      this.md_item.ParcelLocker = item.ParcelLocker
      this.md_item.LineCId = item.LineCId
      this.md_item.LineCSk = item.LineCSk
      this.md_item.PxpayMCode = item.PxpayMCode
      this.md_item.PxpayStoreID = item.PxpayStoreID
      this.md_item.EzpaySMemberUid = item.EzpaySMemberUid
      this.md_item.EzpaySecurityCode = item.EzpaySecurityCode
      this.md_item.EzpayContractNo = item.EzpayContractNo
      this.md_item.EzpayExecutorID = item.EzpayExecutorID
      this.valid_BankMid = ''
      this.valid_JkoMid = ''
      this.$refs.mdEdit.show()
    },
    edit () {
      this.$parent.Loading = true
      if (this.md_item.Storepay == true) {
        this.md_item.Storepay == 1
      } else {
        this.md_item.Storepay == 0
      }
      if (this.md_item.Reserve == true) {
        this.md_item.Reserve == 1
      } else {
        this.md_item.Reserve == 0
      }
      if (this.md_item.OrderOpen == true) {
        this.md_item.OrderOpen == 1
      } else {
        this.md_item.OrderOpen == 0
      }
      if (this.md_item.AppShow == true) {
        this.md_item.AppShow == 1
      } else {
        this.md_item.AppShow == 0
      }
      if (this.md_item.PreOrder == true) {
        this.md_item.PreOrder == 1
      } else {
        this.md_item.PreOrder == 0
      }
      if (this.md_item.ParcelLocker == true) {
        this.md_item.ParcelLocker == 1
      } else {
        this.md_item.ParcelLocker == 0
      }
      return axios.post(API_URL + '/web/shopping/StoreUpdate', {
        id: this.md_item.ID,
        bankMid: this.md_item.BankMid,
        jkoMid: this.md_item.JkoMid,
        lineCId: this.md_item.LineCId,
        lineCSk: this.md_item.LineCSk,
        pxpayMCode: this.md_item.PxpayMCode,
        pxpayStoreID: this.md_item.PxpayStoreID,
        EzpaySMemberUid: this.md_item.EzpaySMemberUid,
        EzpaySecurityCode: this.md_item.EzpaySecurityCode,
        EzpayContractNo: this.md_item.EzpayContractNo,
        EzpayExecutorID: this.md_item.EzpayExecutorID,
        storepay: this.md_item.Storepay,
        reserve: this.md_item.Reserve,
        orderOpen: this.md_item.OrderOpen,
        appShow: this.md_item.AppShow,
        preOrder: this.md_item.PreOrder,
        parcelLocker: this.md_item.ParcelLocker
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('修改成功')
            this.$refs.mdEdit.hide()
            this.query()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
        })
    },
    editConfirm () {
      this.valid_errMsg = false
      // if (!this.md_item.LinepayMid) {
      //   this.valid_errMsg = true
      //   this.valid_LinepayMid = '此欄位必填'
      // } else {
      //   this.valid_LinepayMid = ''
      // }
      // if (!this.md_item.BankMid) {
      //   this.valid_errMsg = true
      //   this.valid_BankMid = '此欄位必填'
      // } else {
      //   this.valid_BankMid = ''
      // }
      if (this.valid_errMsg) {
        this.$parent.verificationErrMsg()
        return
      }

      this.edit()
    },
    delCancel() {
    },
    editCancel () {
      this.$refs.mdEdit.hide()
    },
    OrderOpenOnClick () {
      this.md_item.AppShow = true
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          this.selectListBrands = response.data.data
          this.$parent.Loading = false
        })
        .catch(error => {
          this.selectListBrands = []
          this.$parent.Loading = false
          miniToastr.error(error, "資料讀取異常")
          console.log(error)
        })
    }
  }
}
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
.table-move>tbody>tr {
  cursor: move;
}
.block {
  text-align: center;
  height: 454pt;
}
.front_img {
  height: 450pt;
  position: relative;
  z-index: 1;
}
.bk_div {
  top: 53pt;
  left: 79pt;
  width: 196pt;
  height: 344pt;
  position: absolute;
  z-index: 0;
}
.bk_img {
  width: 320px;
  height: 270px;
}
.active {
  color: red;
}
.isClose {
  color: #ADADAD;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/store/List.vue